import { useTranslations } from "../../hooks/useTranslations";
import Page from "../ui/Page";

const ArbeitAufAbruf = () => {
  const { i18n } = useTranslations();
  return (
    <Page
      title={i18n.arbeitAufAbruf.title}
      backLinkText={i18n.payrollBackLink}
      narrow={true}
    >
      <div>
        <p>
          {i18n.arbeitAufAbruf.paragraph1(
            <a
              href="https://assets-eu-01.kc-usercontent.com/a0e24cdf-7b6b-010e-94fe-bdbecae481ee/4ef41600-6f1e-453d-9c8c-1ebde5ddc422/UNI_Intermittenti.pdf"
              target="_blank"
            >
              {i18n.arbeitAufAbruf.paragraph1FormLinkLabel}
            </a>,
            <a href="mailto:intermittenti@pec.lavoro.gov.it">
              intermittenti@pec.lavoro.gov.it
            </a>,
            <a
              href="https://www.hgv.it/index.php?eID=dumpFile&t=f&f=9348&token=0bd54785d189e4b6880724fc21e76bd8c04a55d9"
              target="_blank"
            >
              {i18n.arbeitAufAbruf.paragraph1InstructionsLinkLabel}
            </a>,
          )}
        </p>
        <p>{i18n.arbeitAufAbruf.paragraph2}</p>
        <p>
          <b>{i18n.arbeitAufAbruf.clarification.label}:</b>{" "}
          {i18n.arbeitAufAbruf.clarification.description}
        </p>
        <p>
          <b>{i18n.arbeitAufAbruf.cancellation.label}:</b>{" "}
          {i18n.arbeitAufAbruf.cancellation.description}
        </p>
        <p>
          <b>{i18n.arbeitAufAbruf.penalties.label}:</b>{" "}
          {i18n.arbeitAufAbruf.penalties.description}
        </p>
        <p>
          <b>{i18n.arbeitAufAbruf.presenceRegister.label}:</b>{" "}
          {i18n.arbeitAufAbruf.presenceRegister.description}
        </p>
      </div>
    </Page>
  );
};

export default ArbeitAufAbruf;
